import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { PopoverController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription } from "rxjs";
import { PopoverOptionsComponent } from "src/components/popup/popover-options/popover-options.component";
import { UserLoginRegistrationResponse } from "src/components/shared-components/enum/enumLoginRegistrationResponse";
import { AccountUpdate } from "src/model/class/general classes/account";
import {
  InvitationBuilding
} from "src/components/shared-components/class/general-classes/building";
import { UsersRole } from "src/model/enum/enumDigitalPlace";
import { iCredential } from "src/model/interface/icredential";
import { AccountService } from "src/service/account.service";
import { AlertService } from "src/service/alert.service";
import { InvitationService } from "src/service/invitation.service";
import { LoaderService } from "src/service/loader.service";
import { SystemRouterService } from "src/service/system-router.service";
import { PasswordValidators } from "src/validators/password-validators";
import { ItalianTaxCodeValidator } from "src/validators/taxcode-validators";
import { taxCodeOrVatRequiredIfRole } from "src/validators/tax-code-vat.validators";




@Component({
    selector: "app-form-create-account",
    templateUrl: "./form-create-account.component.html",
    styleUrls: ["./form-create-account.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormCreateAccountComponent implements OnInit {
  private _logContext: string = "form-create-account.component";
  private _formSubscriptions: Array<Subscription> = null;
  private _translateSubscription: Subscription = null;
  private _errorUnAuthorizeSubscription: Subscription = null;
  private _keyboardSubscriptions: Subscription = null;
  private _isPerformingLogin: boolean = false;
  private _errorCredentialLoginCount: number = 0;
  private _onPerformUnauthorizeAccess = new Subject<number>();
  public arrayRole: Array<UsersRole> = new Array<UsersRole>();
  public roleSelected:UsersRole=UsersRole.BUILDING_ADMINISTRATOR;
  public UsersRole = UsersRole;

  //#region Translate variable
  private _lblAdministrator: string = "";
  private _lblMaintaner: string = "";
  private _lblUser: string = "";
  private _lblDescriptionUser: string = "";
  private _lblDescriptionMaintaner: string = "";
  private _lblDescriptionAdministrator: string = "";
  private _lblpasswordMustMatch: string = "";
  private _lblDescriptionSystem: string = "";
  //#endregion

  public formCreateAccount: UntypedFormGroup = null;
  public cssPlatformClass: string = "";
  public forcedActive: boolean = false;
  public invitation: InvitationBuilding = null;
  @Input("token") token: string = "";

  constructor(
    private _fb: UntypedFormBuilder,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _routerService: SystemRouterService,
    private _systemRouterService: SystemRouterService,
    private _accountService: AccountService,
    private _loaderService: LoaderService,
    private _popoverController: PopoverController,
    private _invitationService: InvitationService
  ) { }

  async ngOnInit() {
    this.forcedActive = false;
    this.loadTranslation();

    this.initializeCreateAccountForm();
    this.subscribeFormEvent();
    await this.initialiseArrayRole();
    if (this.token && this.invitation) {
      
      this.formCreateAccount.get("email").setValue(this.invitation.email);
      this.formCreateAccount.get("email").disable();
    }
  }

  ngOnDestroy() {
    this.unsubscribeFormEvent();

    this._translateSubscription?.unsubscribe();
    this._errorUnAuthorizeSubscription?.unsubscribe();
    this._keyboardSubscriptions?.unsubscribe();
  }

  /**
   * Navigate to privacy policy page
   */
  public onClickPrivacyPolicy() {
    this._systemRouterService.navigateToPrivacyPolicy();
  }

  /**
   * Navigate to privacy policy page
   */
  public onClickConditionsOfService() {
    this._systemRouterService.navigateToConditionsOfService();
  }

  //Show tooltip with requirements for password
  public async showPopover() {
    const popover = await this._popoverController.create({
      component: PopoverOptionsComponent,
      event: event,
      translucent: false,
      showBackdrop: false,
    });

    await popover.present();
  }

  /**
   * Load translated strings
   */
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.administrator",
        "dictionary.maintenance",
        "dictionary.condominium",
        "dictionary.descriptionRoleAdministrator",
        "dictionary.descriptionRoleMaintance",
        "dictionary.descriptionRoleCondominium",
        "dictionary.passwordMustMatch",
        "dictionary.descriptionRoleSystem",
      ])
      .subscribe((translatedStrings) => {
        this._lblAdministrator = translatedStrings["dictionary.administrator"];
        this._lblMaintaner = translatedStrings["dictionary.maintenance"];
        this._lblUser = translatedStrings["dictionary.condominium"];
        this._lblDescriptionAdministrator =
          translatedStrings["dictionary.descriptionRoleAdministrator"];
        this._lblDescriptionMaintaner =
          translatedStrings["dictionary.descriptionRoleMaintance"];
        this._lblDescriptionUser =
          translatedStrings["dictionary.descriptionRoleCondominium"];
        this._lblpasswordMustMatch =
          translatedStrings["dictionary.passwordMustMatch"];
        this._lblDescriptionSystem =
          translatedStrings["dictionary.descriptionRoleSystem"];
      });
  }

  //#endregion

  /**
   * Enter pressed in a field: same as the confirm button, when the form is valid
   */
  public async onSubmitForm(): Promise<void> {
    if (this.formCreateAccount.valid) {
      await this.onClickConfirm();
    }
  }

  /**
   * Handle click login button
   *
   * @returns
   */
  public async onClickConfirm(): Promise<void> {
    try {
      if (
        this.formCreateAccount.value.confirmPassword ==
        this.formCreateAccount.value.password
      ) {
        await this._loaderService.presentLoaderWaiting();
        let accountNew: AccountUpdate = this.formCreateAccount.value;
        accountNew.email = this.formCreateAccount.get("email").value;
        accountNew.name = this.formCreateAccount.get("name").value;
        accountNew.surname = this.formCreateAccount.get("surname").value;
        accountNew.password = this.formCreateAccount.get("password").value;
        accountNew.role = this.formCreateAccount.get("role").value;
        accountNew.acceptTermService = this.formCreateAccount.get(
          "acceptTermService"
        ).value;
        accountNew.acceptCommercialCommunications = this.formCreateAccount.get(
          "acceptCommercialCommunications"
        ).value;
        accountNew.acceptPersonalizingServices = this.formCreateAccount.get(
          "acceptPersonalizingServices"
        ).value;
        if (this.token) {
          accountNew.idUserRemote = this.invitation.idUserRemote;
        }
        
        await this.performRegistration(accountNew);
      } else {
        this.formCreateAccount
          .get("confirmPassword")
          .setErrors({ incorrect: true });

        await this._alertService.presentAlertOk(
          "",
          "",
          this._lblpasswordMustMatch
        );
      }
    } catch (exception) {
    } finally {
      await this._loaderService.dismissLoaderWaiting();
    }
  }

  /**
   * Return to login page
   */
  public onClickGoBack() {
    this._systemRouterService.navigateToDigitalPlaceLogin();
  }

  /**
   * Get label to role by id
   * @param id
   * @returns
   */
  public translateRole(id) {
    let lblReturned: string = "";
    if (id == UsersRole.BUILDING_ADMINISTRATOR) {
      lblReturned = this._lblAdministrator;
    }
    if (id == UsersRole.MAINTANER) {
      lblReturned = this._lblMaintaner;
    }
    if (id == UsersRole.RESIDENT) {
      lblReturned = this._lblUser;
    }
    if (id == UsersRole.SYSTEM) {
      lblReturned = "System";
    }
    return lblReturned;
  }

  /**
   * Set role on ion-select
   */
  public onClickSelectItem(idRole) {
    this.formCreateAccount.get("role").setValue(idRole);
  }

  public isSelectedRole(idRole) {
    if (this.formCreateAccount.get("role").value == idRole) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Get the role of the page
   * @param idRole
   * @returns
   */
  public getRolePage(idRole) {
    let returnedString: string = "";
    if (idRole == UsersRole.BUILDING_ADMINISTRATOR) {
      returnedString = this._lblAdministrator;
    }
    if (idRole == UsersRole.MAINTANER) {
      returnedString = this._lblMaintaner;
    }
    if (idRole == UsersRole.RESIDENT) {
      returnedString = this._lblUser;
    }
    return returnedString;
  }

  /**
   * Get the description of the role
   * @param idRole
   * @returns
   */
  public getDescriptionRole(idRole) {
    let returnedDescription: string = "";
    if (idRole == UsersRole.BUILDING_ADMINISTRATOR) {
      returnedDescription = this._lblDescriptionAdministrator;
    }
    if (idRole == UsersRole.MAINTANER) {
      returnedDescription = this._lblDescriptionMaintaner;
    }
    if (idRole == UsersRole.RESIDENT) {
      returnedDescription = this._lblDescriptionUser;
    }
    if (idRole == UsersRole.SYSTEM) {
      returnedDescription = this._lblDescriptionSystem;
    }
    return returnedDescription;
  }

  /**
   * Return icon by role
   */
  public returnIcon(idRole) {
    let returnedIcon: string = "";
    if (idRole == UsersRole.BUILDING_ADMINISTRATOR) {
      returnedIcon = "shield";
    }
    if (idRole == UsersRole.MAINTANER) {
      returnedIcon = "build";
    }
    if (idRole == UsersRole.RESIDENT) {
      returnedIcon = "business";
    }
    if (idRole == UsersRole.SYSTEM) {
      returnedIcon = "construct";
    }
    return returnedIcon;
  }

  /**
   * Handle callback event for request login
   *
   * @param objectLogin
   */
  public async onRequestLogin(objectLogin: iCredential): Promise<void> {
    if (!this._isPerformingLogin) {
    }
  }

  /**
   * This method create an array containing  "UsersRole"
   * This array is used to dinamically initialise the "ion-select-option"-elements list in the template.
   */
  private async initialiseArrayRole(): Promise<void> {
    try {
      const defaultRole = UsersRole.BUILDING_ADMINISTRATOR;
      let role = defaultRole;

      if (this.token) {
        this.invitation = await this._invitationService.getInvitationByToken(
          this.token
        );
        role = this.invitation?.role || defaultRole;
      }
      this.arrayRole.push(role);
      this.formCreateAccount.get("role").setValue(role);
      this.roleSelected=role;
      
      if(this.roleSelected!=UsersRole.BUILDING_ADMINISTRATOR){
         this.formCreateAccount.get("taxCode")?.clearValidators();
         this.formCreateAccount.get('taxCode')?.updateValueAndValidity();

         this.formCreateAccount.get('VATNumber')?.clearAsyncValidators();
         this.formCreateAccount.get('VATNumber')?.updateValueAndValidity();
      }
      
    } catch (exception) {
      this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * Initialize login form plant
   */
  private initializeCreateAccountForm(): void {
    this.formCreateAccount = this._fb.group({
      email: new UntypedFormControl("", {
        validators: Validators.compose([Validators.email, Validators.required]),
      }),

      password: new UntypedFormControl("", {
        validators: Validators.compose([
          Validators.minLength(4),
          Validators.required,
          PasswordValidators.isPWDCorret(),
        ]),
      }),
      confirmPassword: new UntypedFormControl("", {
        validators: Validators.compose([
          Validators.minLength(4),
          Validators.required,
          PasswordValidators.isPWDCorret(),
        ]),
      }),
      name: new UntypedFormControl("", Validators.required),
      surname: new UntypedFormControl("", Validators.required),
      role: new UntypedFormControl(UsersRole.BUILDING_ADMINISTRATOR, [
        Validators.required,
      ]),
      acceptTermService: new UntypedFormControl(false, Validators.requiredTrue),
      acceptCommercialCommunications: new UntypedFormControl(false),
      acceptPersonalizingServices: new UntypedFormControl(false),
      taxCode: new UntypedFormControl("", [Validators.required,ItalianTaxCodeValidator]),
      VATNumber: new UntypedFormControl("")
    },
    {
      validators: [taxCodeOrVatRequiredIfRole(UsersRole.BUILDING_ADMINISTRATOR)]
      }
    );
  }

  /**
   * Subscribe value change event from each form field.
   */
  private subscribeFormEvent(): void {
    this._formSubscriptions = new Array<Subscription>();
    // "The two passwords must match" under the confirmation field, while typing
    this._formSubscriptions.push(PasswordValidators.watchPasswordMatch(this.formCreateAccount));
  }

  /**
   * Perform account registration
   *
   * @param accountNew Account new data
   */
  private async performRegistration(accountNew: AccountUpdate): Promise<void> {
    let registrationResponseCode: UserLoginRegistrationResponse =
      UserLoginRegistrationResponse.NO_EXCEPTION;

    try {
      await this._loaderService.presentLoaderWaiting();

      await this._accountService.createDigitalPlaceAccount(accountNew);
    } catch (exception) {
      registrationResponseCode = exception.error.errorCode;
    } finally {
      await this._loaderService.dismissLoaderWaiting();

      await this._alertService.presentAlertDigitalAccountManage(
        registrationResponseCode,
        accountNew.email
      );

      if (
        registrationResponseCode === UserLoginRegistrationResponse.NO_EXCEPTION
      ) {
        this._routerService.navigateToDigitalPlaceLogin();
      }
    }
  }

  /**
   * Unsubscribe to form event events
   */
  private unsubscribeFormEvent(): void {
    for (const sub of this._formSubscriptions) {
      sub.unsubscribe();
    }
  }
}
